import React, { useEffect, useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import { PDFDownloadLink } from "@react-pdf/renderer";
import axios from "axios";
import terbilang from 'terbilang';

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import MyReportvoucher from "component/utils/MyReportvoucherpdt1";
import JurnalFormHeader from "component/akunting/transaksi/jurnal-biaya/JurnalFormHeader";
import JurnalDetailTable from "component/akunting/transaksi/jurnal-biaya/JurnalDetailTable";

function JurnalBiaya() {
  const { user } = useAuth();
  const [data, setData] = useState([
    {
      group_account_table: "",
      group_account_div: "",
      chart_account_code: "",
      chart_account_desc: "",
      debit: "",
      credit: "",
      entry_by: user?.name,
      lokasi: user?.company,
    },
  ]);
  const [isViewMode, setIsViewMode] = useState(false);
  const [formInput, setFormInput] = useState({
    doc_no: "",
    amount_voucher: "",
    value_voucher:"",
    dibuat_oleh: "",
    disetujui_oleh: "",
    ket: "",
    rekening_code: "",
    entry_by: user?.name,
    lokasi: user?.company,
  });

  const [isSaved, setIsSaved] = useState(false);

  useEffect(() => {
    document.title = "Green Hill Kemuning | Group Account";
    window.scrollTo(0, 0);
  }, []);

  function formatTerbilang(nominal) {
    const str = terbilang(nominal);
    return str
      .replace(/^satu ribu$/, 'seribu')
      .replace(/^satu ratus$/, 'seratus');
      // .replace(/^satu juta$/, 'sejuta');
  }
  useEffect(() => {
    const totalDebit = data.reduce((sum, row) => sum + (parseFloat(row.debit) || 0), 0);
    // const totalCredit = data.reduce((sum, row) => sum + (parseFloat(row.credit) || 0), 0);

    // Pilih salah satu yang bukan 0 sebagai 'amount_voucher'
    const amount_voucher = totalDebit;
    const value_voucher = amount_voucher ? formatTerbilang(amount_voucher) + ' rupiah' : '';

    setFormInput((prev) => ({
      ...prev,
      amount_voucher: amount_voucher,
      value_voucher: value_voucher
    }));
  }, [data]);

  const handleChangeInput = (field, value) => {
    setFormInput((prev) => ({ ...prev, [field]: value }));
  };

  const handleChangeRow = (index, key, value) => {
    const updatedData = [...data];

    if (key === null && typeof value === "object") {
      updatedData[index] = value;
    } else {
      // jika field debit atau credit, hanya simpan angka (tanpa Rp/format)
      if (key === "debit" || key === "credit") {
        const numericValue = value.toString().replace(/[^0-9]/g, ""); // hanya angka
        updatedData[index][key] = parseInt(numericValue || "0", 10);
      } else {
        updatedData[index][key] = value;
      }
    }

    setData(updatedData);
  };


  const handleAddRow = () => {
    setData([
      ...data,
      {
        group_account_table: "",
        group_account_div: "",
        chart_account_code: "",
        chart_account_desc: "",
        debit: "",
        credit: "",
        entry_by: user?.name,
        lokasi: user?.company,
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    const updatedData = [...data];
    updatedData.splice(index, 1);
    setData(updatedData);
  };

  const handleSubmit = async () => {
    try {
      if (!formInput.rekening_code) {
        showError("Silakan pilih masuk kemana terlebih dahulu.");
        return;
      }
    
      const confirmed = await showConfirm({
        title: `Simpan Jurnal Biaya ${formInput.rekening_code}`,
        text: `Apakah Anda yakin ingin menyimpan data Jurnal Biaya ${formInput.rekening_code}?`,
        confirmButtonText: 'Simpan'
      });

      if (!confirmed) return;

      const jsonHVoucher = JSON.stringify(formInput);
      const HVoucher = await axios.post(
        `${process.env.REACT_APP_API}/insert-h-voucher-biaya`,
        {
          InRequestJson: jsonHVoucher,
        }
      );

      if (HVoucher.data.msg_code === "200" || HVoucher.data.msg_code === "201") {
        const doc_no = HVoucher.data.data[0].doc_no;
        setFormInput((prev) => ({
          ...prev,
          doc_no: doc_no
        }));
        await insertDVoucher(doc_no, formInput.ket);
      } else {
        resetData();
        resetFormInput();
        showError(HVoucher.data.msg_desc || "Gagal menyimpan data.");
        setIsViewMode(false);
      }
    } catch (err) {
      resetData();
      resetFormInput();
      console.error(err);
      showError("Terjadi kesalahan saat menyimpan data.");
      setIsViewMode(false);
      setIsSaved(false);
    }
  };

  const insertDVoucher = async (doc_no, ket) => {
    let isValid = true;
    const jsonDVoucher = data.map((item, index) => {
      const debit = parseFloat(item.debit) || 0;
      const credit = parseFloat(item.credit) || 0;
      if (!item.chart_account_code || (debit === 0 && credit === 0)) {
        showError(`Baris ke-${index + 1}: Kode akun wajib diisi dan salah satu dari Debit/Kredit harus ada.`);
        isValid = false;
      }
      return {
        ...item,
        doc_no: doc_no,
        ket: ket,
        debit,
        credit
      };
    });
    if (!isValid) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/insert-d-voucher-biaya`,
        {
          InRequestJson: JSON.stringify(jsonDVoucher),
          rekening_code: formInput.rekening_code
        }
      );

      if (response.data.msg_code === "200" || response.data.msg_code === "201" ) {
        showSuccess("Data berhasil disimpan!");
        setIsSaved(true);
        setIsViewMode(true);
        await tampilVoucher(doc_no);
      } else {
        showError(response.data.msg_desc || "Gagal menyimpan detail voucher.");
      }
    } catch (error) {
      console.error("Error insert D-Voucher:", error);
      showError("Terjadi kesalahan saat menyimpan detail voucher.");
    }
  };

  const tampilVoucher = async (doc_no) => {
    try {
      const tampilHVoucher = await axios.post(
        `${process.env.REACT_APP_API}/tampil-header-voucher-biaya`,
        {
          doc_no: doc_no
        }
      );
      
      const tampilDVoucher = await axios.post(
        `${process.env.REACT_APP_API}/tampil-detail-voucher-biaya`,
        {
          doc_no: doc_no
        }
      );

      if (
        (tampilHVoucher.data.msg_code === "200" || tampilHVoucher.data.msg_code === "201") &&
        (tampilDVoucher.data.msg_code === "200" || tampilDVoucher.data.msg_code === "201")
      ) {
        setFormInput(tampilHVoucher.data.data[0]);
        setData(tampilDVoucher.data.data);
        setIsSaved(true);
      } else {
        showError(tampilHVoucher.data.msg_desc || "Gagal tampilkan voucher.");
      }
    } catch (error) {
      console.error("Error tampilkan Voucher:", error);
      showError("Terjadi kesalahan saat tampilkan voucher.");
    }
  };

  const handlePrint = () => {
    if (!isSaved) return;
    window.print();
  };

  const resetFormInput = () => {
    setFormInput({
      doc_no: "",
      amount_voucher: "",
      value_voucher: "",
      dibuat_oleh: "",
      disetujui_oleh: "",
      ket: "",
      rekening_code: "",
      entry_by: user?.name,
      lokasi: user?.company,
    });
  };

  const resetData = () => {
    setData([
      {
        group_account_table: "",
        group_account_div: "",
        chart_account_code: "",
        chart_account_desc: "",
        debit: "",
        credit: "",
        entry_by: user?.name,
        lokasi: user?.company,
      },
    ]);
  };

  const handleResetMode = () => {
    setIsViewMode(false);
    setIsSaved(false);
    resetData();
    resetFormInput();
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />

        <div className="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row px-4">
                <div className="card shadow p-3">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="card-title m-0">Jurnal Biaya Management</h5>
                      <div className="d-flex gap-3 align-items-center">
                        <i
                          className="bx bxs-save"
                          title="Simpan"
                          style={{ color: "blue", fontSize: 30, cursor: "pointer" }}
                          onClick={handleSubmit}
                        ></i>
                        {/* <i
                          className={`bx bxs-printer ${!isSaved ? "text-muted" : ""}`}
                          title="Print"
                          style={{ color: "blue", fontSize: 30, cursor: isSaved ? "pointer" : "not-allowed"}}
                          onClick={handlePrint}
                        ></i> */}
                        {isSaved && (
                          <PDFDownloadLink
                            document={
                              <MyReportvoucher
                                header={formInput}
                                details={data}
                                userBy={user?.name}
                              />
                            }
                            fileName={`voucher-jurnal-${formInput.doc_no || "baru"}.pdf`}
                          >
                            {({ loading }) => (
                              <i
                                className={`bx ${loading ? "bx-loader-circle bx-spin" : "bxs-download"}`}
                                title="Download PDF"
                                style={{ fontSize: 30, cursor: "pointer", color: "green" }}
                              />
                            )}
                          </PDFDownloadLink>
                        )}
                      </div>
                    </div>

                    <JurnalFormHeader
                      formData={formInput}
                      onChange={handleChangeInput}
                    />

                    <JurnalDetailTable
                      data={data}
                      onChangeRow={handleChangeRow}
                      onAddRow={handleAddRow}
                      onRemoveRow={handleRemoveRow}
                      isViewMode={isViewMode}
                      onBack={handleResetMode}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
      </div>
    </div>
  );
}

export default JurnalBiaya;
